module.exports = __webpack_public_path__ + "img/correct-green.8c734c84.svg";